module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("2.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h3', {
    staticClass: "chaptitle"
  }, [_vm._v("THE INTERSECTIONS BETWEEN OUR INTERNAL LANDSCAPE AND OUR SOCIOPOLITICAL CONDITIONS")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“An environment is also an inward reality.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("—James Baldwin")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "images",
      "src": "images/fig4.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The internal landscape takes many forms, depending on the context. For the purposes of this book, I am talking about how we see ourselves through experiences, beliefs, emotions, memories, images, ideas, and internalization of outside beliefs. Your inner landscape is not just your imagination or mind’s eye; it is where your spirit and nature reside. It is the terrain of the self. How you see yourself, define yourself, and understand your feelings is through the panoramic view of your life. It is through this view that you determine who you are—in this vast countryside of self, where we often retreat to rejuvenate and restore. We may also go here when we are grappling with outside stimuli. Some of us retreat into our inner landscape when we feel uncomfortable in the outside world. Our inner landscape helps us to define things like what a community is, what a home is, what is safe and what is not, what is positive and what is negative, and so on.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It is common to carry a landscape from memory forward in your mind. You often hear statements like, “The ocean is my church,” “My home is actually in the town I grew up in,” “My journey is a long road,” or “My path is windy.” Even the Beatles song “The Long and Winding Road” uses landscape metaphors to describe a feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Nature is such a powerful influence on our overall emotional and mental state. I remember living in the dense part of a major city, where there was nothing but cement and brick. Over time, I became so hungry for the sight of a tree or any type of greenery. I grew up on a ranch, surrounded by trees and pastures, and the memory of green made me feel safe and comforted. What nature is part of your memories, and how does it weave into your emotions, beliefs, and understandings?")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Your landscape may have boundaries, hills, edges, and mountains; it may be cold and windy, sunny and dry, lush or ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("desert-like. Visualizing your inner landscape helps you to determine how you feel about things, where you are on your journey, and where you can go. It can be a powerful visualization that can help you find your way or move you forward when you feel stuck. It can be a way to check in with yourself. Closing your eyes and imagining your landscape can help to tell you where you are at any given moment.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "title2"
  }, [_vm._v("Visualization Exercise")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Find a comfortable, safe place to settle in for about ten to fifteen minutes. Close your eyes and imagine your mind as a landscape.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Take a moment to look around.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Notice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("What does it look like?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Who is there?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What is the weather like?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How far can you see?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Are there rolling hills or cliffs?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Do this a few times and ask yourself, “Does it change from time to time? If so, how?”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Now that you have looked at your internal landscape, let’s look at the sociopolitical factors that also make up your identity. Sociopolitical factors are anything that is a combination of sociological and political factors that influence the actions, beliefs, and understandings of people and groups.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Issues like human rights, sexual harassment and assault, homelessness, healthcare, discrimination, poverty, and immigration are examples of sociopolitical factors. Anything ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("can be a factor. These factors affect all bodies and groups. For example, the consequences of poverty can be poor health, inability to access education, isolation, discrimination, and limited possibilities. These factors directly affect social justice and equality. Certain bodies experience profound discrimination because they identify with a group that has been labeled as inferior, wrong, bad, predators, villains, criminals, and so on.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It is somewhat easy to connect the dots from sociopolitical factors to influence on a body, but other consequences might be more hidden. We can understand the limiting factors and how they may play into the shaping of beliefs, ideas, identities, and behaviors, but there are other less evident factors, such as shame, unworthiness, self-hatred, insecurities, and mental health issues, just to name a few. Different bodies experience these factors in different ways.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("When working with someone, it is essential to consider the factors that might be affecting them. As you work to identify your internal landscape, it is important to consider what sociopolitical factors may have influenced your beliefs, ideas, actions, and understandings. Even if you did not directly experience a factor personally, some factors can indirectly affect you. Perhaps your parents have experienced something that you personally have not, yet their experiences are shaping your ideas and beliefs. For example, if your parents or grandparents were immigrants, but you were born in your current country of residence, then perhaps the sociopolitical factors they experienced directly are indirectly affecting you.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make a list of the factors you recognize within your community or that you have personally experienced. How have they shaped you and your community? Give some thought to how they have influenced you and others. What factors do you see that are influencing your thoughts, emotions, actions, and beliefs?")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "images",
      "src": "images/fig5.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa536ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter02.vue
// module id = 84
// module chunks = 0